import moment from 'moment';
import {APP_CONFIGS} from "../config/configs";

export const elapsedTimeSince = dateTime => {
    const start = strToMomentAndClean(dateTime);
    if (start) {
        return moment.duration(moment().diff(start));
    }
};

export const decodeHtml = html => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
};

export const replaceSpecialChars = word => {
    const specials = 'áàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ'.split('');
    const regulars = 'aaaaaeeeeiiiiooooouuuucAAAAAEEEEIIIIOOOOOUUUUC'.split('');

    if (!word || typeof word !== 'string') {
        return word;
    }

    const cleanWord = word.split('');
    for (let i = 0; i <= cleanWord.length; i++) {
        const specialIdx = specials.indexOf(cleanWord[i]);
        if (specialIdx !== -1) {
            cleanWord[i] = regulars[specialIdx];
        }
    }

    return cleanWord.length ? cleanWord.join('') : word;
};

export const replacements = (target, find, replacements) => {
    if (!target) return target;
    if (typeof find === 'string') find = [find];
    if (typeof replacements === 'string') replacements = find.map(() => replacements);
    if (!Array.isArray(find) || !Array.isArray(replacements)) return target;
    if (!replacements.length) return target;

    for (let i = 0; i < find.length; i++) {
        const regex = new RegExp(find[i], "g");
        target = target.replace(regex, replacements.hasOwnProperty(i) ? replacements[i] : replacements[replacements.length - 1]);
    }

    return target;
};

export const refSelectAll = (ref, alternativeRef) => {
    const r = ref ? ref : alternativeRef;
    if (r && r.current && typeof r.current.select === 'function') {
        r.current.select();
    }
};

export const refFocus = (ref, alternativeRef) => {
    const r = ref ? ref : alternativeRef;
    if (r && r.current && typeof r.current.focus === 'function') {
        r.current.focus();
        /*r.current.scrollIntoView({behavior: 'smooth'});
        r.current.scrollTop += 100;*/
    }
};

export const refBlur = (ref, alternativeRef) => {
    const r = ref ? ref : alternativeRef;
    if (r && r.current && typeof r.current.blur === 'function') {
        r.current.blur();
    }
};

export const strToMomentAndClean = dateStr => {
    if (dateStr instanceof moment && dateStr.isValid()) return dateStr.clone();
    if (!dateStr) return null;

    const date = moment(dateStr);
    if (!date.isValid()) {
        return null;
    }

    return date.clone();
};

export const distinct = (array) => {
    return array.filter((elem, pos, arr) => {
        return arr.indexOf(elem) === pos;
    });
};

export const subStrIdx = (str, substring, n) => {
    let times = 0, index = null;

    while (times < n && index !== -1) {
        index = str.indexOf(substring, index + 1);
        times++;
    }

    return index;
};

export const extractMonth = (date) => {
    const idxAfter2Hiffen = subStrIdx(date, '-', 1) + 1;
    return date.substring(idxAfter2Hiffen, idxAfter2Hiffen + 2);
};

export const extractDay = (date) => {
    const idxAfter2Hiffen = subStrIdx(date, '-', 2) + 1;
    return date.substring(idxAfter2Hiffen, idxAfter2Hiffen + 2);
};

export const enumerateDaysBetweenDates = (startDate, endDate, startInclusive = false) => {
    const dates = [];

    const currDate = moment(startDate).startOf('day');
    const lastDate = moment(endDate).startOf('day');

    if (startInclusive) {
        dates.push(currDate.clone().toDate());
    }
    while (currDate.add(1, 'days').diff(lastDate) < 0) {
        dates.push(currDate.clone().toDate());
    }

    dates.push(lastDate.clone().toDate());

    return dates;
};

export const enumerateMonthsBetweenDates = (startDate, endDate) => {
    const dates = [];

    const currDate = moment(startDate).startOf('day');
    const lastDate = moment(endDate).startOf('day');

    dates.push(currDate.clone().format('MMMM'));
    while (currDate.add(1, 'months').diff(lastDate) < 0) {
        dates.push(currDate.clone().format('MMMM'));
    }

    dates.push(lastDate.clone().format('MMMM'));

    return dates;
};

export const extractMonthName = (date) => moment(date).clone().format('MMMM').toLowerCase();

export const addZero = (value) => {
    const str = '' + value;
    return str.length < 2 ? '0' + str : str;
};

export const addZeroInFront = (value) => {
    const str = '' + value;
    return str.length < 2 ? str + '0' : str;
};

export const formatPrice = (value, currency, lang = APP_CONFIGS.APP.defaultLanguage) => {
    return parseFloat(value).toLocaleString(lang, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) + currency;
};

export const formatDate = (date) => {
    /*let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');*/
    return moment(date).format('YYYY-MM-DD');
};

export const extractIntegerPart = (value, formatted = false, lang = APP_CONFIGS.APP.defaultLanguage) => {
    if (isNaN(value)) {
        return value;
    }

    const valueStr = Math.floor(value).toLocaleString(lang);

    return formatted ? addZero(valueStr) : valueStr;
};

export const extractDecimalPart = (value, withSeparator = false, lang = APP_CONFIGS.APP.defaultLanguage) => {
    if (isNaN(value)) {
        return value;
    }

    const valueStr = parseFloat(value).toLocaleString(lang, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) + '';
    const charsCount = withSeparator ? 3 : 2;
    return valueStr.substring(valueStr.length - charsCount);
};

export const max = (arr) => Math.max(...arr);

export const min = (arr) => Math.min(...arr);

export const capitalize = str => str ? str[0].toUpperCase() + str.toLowerCase().substring(1) : str;

export const currencyToSymbol = (currency) => {
    const curr = currency ? currency.toUpperCase() : currency;
    return APP_CONFIGS.CURRENCY_SYMBOLS.hasOwnProperty(curr) ? APP_CONFIGS.CURRENCY_SYMBOLS[curr] : '€';
};